module.exports = __webpack_public_path__ + "static/media/file-icon.71c590a5.svg";